import { Directive, ElementRef, OnInit, Optional } from '@angular/core';
import { FormControlName } from '@angular/forms';

@Directive({
	/* eslint-disable @angular-eslint/directive-selector */
	selector: '[formControlName]',
})
export class NativeElementInjectorDirective implements OnInit {
	constructor(
		private element: ElementRef,
		@Optional() private formControlName: FormControlName
	) {}

	ngOnInit() {
		if (this.formControlName) {
			if (this.formControlName.control) {
				(<any>this.formControlName.control).nativeElement = this.element.nativeElement;
			} else {
				(<any>this.formControlName).nativeElement = this.element.nativeElement;
			}
		}
	}
}
